var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.918 13.848a12.09 12.09 0 01-3.777.009c.06-.573.092-1.282.11-1.89-.902-.542-1.719-1.451-2.307-2.498C5.197 9.031 4.282 8.345 4 7.5 3.5 6 3 5 3 5s1.055.337 2.006.87C5.114 3.154 6.673 1 10 1c3.327 0 4.887 2.154 4.995 4.87A12.49 12.49 0 0117 5s-.5 1-1 2.5c-.281.844-1.197 1.53-1.943 1.969-.584 1.038-1.392 1.94-2.286 2.485.03.608.075 1.318.147 1.894zm-5.005.783c-.844.279-1.692.506-2.43.684-1.382.332-2.56 1.282-3.07 2.61L1 19h18l-.414-1.076c-.51-1.327-1.688-2.277-3.07-2.609a31.048 31.048 0 01-2.43-.684c-.989.241-2.023.369-3.086.369a13.03 13.03 0 01-3.087-.369z",
    fill: "#9A9CAC"
  })));
}

export default SvgProfileIcon;